import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { ReseauService } from '@/service/reseau.service';
import { Poly } from '@/dto/polygon/poly';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { Loader, LoaderOptions } from '@googlemaps/js-api-loader';
import { Router } from '@angular/router';


const GOOGLE_MAPS_API_KEY: string = window.env.googleMapsAPIKey;

const mapLoaderOptions: LoaderOptions = {
  apiKey: GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places', 'drawing', 'visualization', 'geometry'],
  language: "fr",
  region: "fr",
}
const renderer = {
  render({ count, position }) {
    return new google.maps.Marker({
      label: { text: String(count), color: "white", fontSize: "12px" },
      position,
      icon: "assets/img/",
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    })
  }
}
@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss']
})
export class MapComponent implements OnInit, OnDestroy, AfterViewInit {
  private unsubscribe: Subscription[] = [];
  objectKeys = Object.keys;
  public map: any;
  private markers = [];
  private lonlatset = false;
  private lat = 0;
  private lon = 0;
  public listPos: any = [];
  public zoom: number;
  public upperRightCorner: number[];
  public downLeftCorner: number[]
  public latitude: string;
  public longitude: string;
  private poly: Poly;
  public open_hours: any;
  public activePos: any;
  private markerCluster: MarkerClusterer;

  private mapOptions = {
    center: {
      lat: 48.8773595,
      lng: 2.2885282
    },
    zoom: 8
  }




  @ViewChild("search", { static: false }) public searchElementRef: ElementRef;
  public searchControl: FormControl;

  constructor(private translateService: TranslateService, private ngZone: NgZone,
    private reseauService: ReseauService, public router: Router) {

  }

  ngAfterViewInit(): void {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
        this.mapOptions.center.lat = position.coords.latitude;
        this.mapOptions.center.lng = position.coords.longitude;
        this.initializeMap();
      }, (error: GeolocationPositionError) => {
        this.initializeMap();
      });
    } else {
      this.initializeMap();
    }
  }

  ngOnInit() {

  }

  initializeMap() {
    const mapLoader = new Loader(mapLoaderOptions);
    mapLoader
      .load()
      .then((google) => {
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
        this.setPositiongoogle();

        this.map.addListener('bounds_changed', () => {
          if (this.map.getBounds()) {
            this.poly = new Poly();
            this.poly.upperRightCorner = [this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getNorthEast().lat()];
            this.poly.downLeftCorner = [this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getSouthWest().lat()];
            this.zoom = this.map.getZoom();
            if (this.listPos.length === 0) {
              this.poly.center = [this.map.center.lng(), this.map.center.lat()];
              this.updateData();
            }
          }
        })


        const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          fields: ["address_component", "adr_address", "formatted_address", "geometry", "icon", "name", "business_status", "photo", "type", "url", "utc_offset_minutes", "vicinity"],
        });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {

            ////get the place result
            const place: google.maps.places.PlaceResult = autocomplete.getPlace();
            ////verify result
            if (!place.geometry) {
              return;
            }

            ////set latitude, longitude and zoom
            this.map.setCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });

            this.clearMarker();

            this.map.setZoom(12);

            this.poly.center = [place.geometry.location.lng(), place.geometry.location.lat()];

            this.updateData();
          });
        });
      }).catch(e => {
        console.log(e);
      });;
  }

  updateData() {
    this.unsubscribe.push(this.reseauService.getInsidePoly(this.poly).subscribe(val => {
      this.listPos = val;
      const total = val.length;
      for (let i = 0; i < total; i++) {
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(val[i]['latitude'], val[i]['longitude']),
          map: this.map,
          title: val[i]["storename"]
        });
        marker["pos"] = val[i];
        marker.addListener("click", () => {
          this.markers.forEach(c => {
            c.setAnimation(null);
          });
          if (marker.getAnimation()) {
            marker.setAnimation(null);
          } else {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            this.activePos = marker["pos"];
            this.open_hours = this.activePos["openHours"];
          }
        });
        this.markers.push(marker);

      }
      this.markerCluster = new MarkerClusterer(
        {
          map :this.map,
          markers: this.markers,
          renderer: renderer
        });
    }));
  }

  setPositiongoogle() {
    if (this.map && this.lonlatset === false && this.lat !== 0 && this.lon !== 0) {
      this.lonlatset = true;
      this.map.setCenter(new google.maps.LatLng(this.lat, this.lon));
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(this.lat, this.lon),
        map: this.map,
        title: ''
      });
      this.markers.push(marker);
    }
  }

  clearMarker() {
    this.markers = [];
  }

  ngOnDestroy() {
    this.map = null;
    this.unsubscribe.forEach(s => s.unsubscribe());
    this.clearMarker();
  }

  renderDateOpenHours() {
    const orderRender = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
    let result = {}
    var arr = [];

    orderRender.forEach(item => {
      let dataDate = Object.keys(this.open_hours).find(e => e.toLowerCase() == item.toLowerCase())
      if (dataDate === undefined)
        dataDate = item;
      //dataDate = this.translateService.instant(dataDate.toLowerCase());
      result[dataDate] = this.open_hours[dataDate]

    })
    for (var key in result) {
      if (result.hasOwnProperty(key)) {
        arr.push([this.translateService.instant(key), result[key]]);
      }
    }
    return arr
  }

}
